import * as React from "react";
import { Button } from "./Button";
import ACTIONS from "./EventLibrary";
import { rudderStackTrack } from "./Track";

export function ModelDexCTA({ displayName }) {

    return <div className="cta">
        <div className="content">
            <h3>Don't Want To Build A Dashboard? Use The Pre-Built DEX Dashboard For Free!</h3>
            <p />
            {displayName ? <p>Use Now {displayName}.</p> : ""}
            <Button onClick={() => { rudderStackTrack(ACTIONS.docs_discordcta_clicked, { value: "" }); }} target="_blank" rel="noreferrer noopener" href={"https://www.covalenthq.com/platform/increment/#/pages/covalent/dexscovery/"}>Use Now</Button>
        </div>
        <style jsx>
            {`            
            .cta {
                padding: 0.5rem 0 2rem;
            }
            h3 {
                margin-top: 0rem;
                margin-bottom: 1rem;
            }
            .content {
                color: var(--dark);
                background: var(--code-background);
                border: 1px solid var(--code-border);
                line-height: 20px;
                padding: 12px 20px;
                border-radius: var(--border-radius);
              }
              .cta :global(p:first-of-type) {
                padding: 0;
              }
    
            `}
        </style>
    </div>;
}
